import React from "react";
import { Calendar, Building2, ArrowRight } from "lucide-react";

const fmtDate = (iso) => (iso ? String(iso).slice(0, 10) : "—");

export const ReportPreview = ({ report, children }) => {
  if (!report) return null;
  const dr = report.date_range || {};
  return (
    <div data-testid="report-preview" className="rounded-2xl border border-slate-200 bg-white overflow-hidden">
      <div className="bg-gradient-to-br from-slate-900 via-slate-900 to-slate-800 px-6 py-5">
        <div className="flex items-start justify-between gap-4 flex-wrap">
          <div>
            <div className="flex items-center gap-2">
              <span className="text-[10px] uppercase tracking-wider font-semibold text-violet-300">
                Report
              </span>
              <span className="text-[10px] text-white/40">·</span>
              <span className="text-[10px] uppercase tracking-wider font-medium text-white/60">
                {report.metadata?.inferred_by_ai ? "Generated via Ask AI" : "Template"}
              </span>
            </div>
            <h1 className="text-xl font-semibold text-white tracking-tight mt-1">
              {report.report_name}
            </h1>
            <div className="mt-2 flex items-center gap-4 flex-wrap text-xs text-white/70">
              <span className="inline-flex items-center gap-1.5">
                <Building2 className="w-3.5 h-3.5" />
                {(report.filters?.project_id) || "All Projects"}
              </span>
              <span className="inline-flex items-center gap-1.5">
                <Calendar className="w-3.5 h-3.5" />
                {fmtDate(dr.from)} <ArrowRight className="w-3 h-3" /> {fmtDate(dr.to)}
              </span>
              {report.source_basis && (
                <span className="inline-flex items-center gap-1.5">
                  <span className="text-white/40">·</span>
                  Source basis: <strong className="text-white">{report.source_basis}</strong>
                </span>
              )}
            </div>
          </div>
          <div>{children}</div>
        </div>
      </div>
      {report.assumptions?.length > 0 && (
        <div className="px-6 py-3 bg-amber-50/50 border-b border-amber-100">
          <div className="flex items-start gap-2">
            <span className="text-[10px] uppercase tracking-wider font-semibold text-amber-800 flex-shrink-0 mt-0.5">
              Assumptions
            </span>
            <ul className="text-xs text-slate-700 leading-relaxed space-y-0.5">
              {report.assumptions.map((a, i) => (
                <li key={i}>• {a}</li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReportPreview;
